"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @summary Wraps up all of the trace data needed to send an event.
 * @param {string} application - the type of the Seismic application.  The best practice is to use the Applications "enum" type. Please note that application has to be passed in to the constructor due to the fact that this web app could be embedded into another app, such as Salesforce or one of the Office add-ins.
 * @param {string} product - the name of the Seismic product.  The best practice is to use the Products "enum" type.
 * @param {string} device - the type of device.  The best practice is to use the Devices "enum" type.
 * @param {string} operatingSystem - the type of operating system.  The best practice is to use the OperatingSystems "enum" type.
 */
function createTrace(_a) {
    var application = _a.application, applicationVersion = _a.applicationVersion, device = _a.device, operatingSystem = _a.operatingSystem, operatingSystemDetail = _a.operatingSystemDetail;
    return {
        application: application,
        applicationVersion: applicationVersion,
        device: device,
        operatingSystem: operatingSystem,
        operatingSystemDetail: operatingSystemDetail,
    };
}
exports.default = createTrace;
//# sourceMappingURL=createTrace.js.map